import axios from "axios";
export const getCont = (data) => {
  return axios.get(`/api/web/release/newshare/${data.id}&${data.type||0}`);
    // return axios.get(`/api/web/release/share/${data.id}`);
};
export const getPreview = (data) => {
  // return axios.get(`/api/web/release/newshare/${data.id}&${data.type}`);
  return axios.get(`/api/web/${data.type}/preview/${data.id}`);
};
// 专题详情
export const specialSubject = (id) => {
  return axios.get(`/api/web/specialSubject/info/${id}`);
};
// 发布列表
export const notokenList = (data) => {
  return axios.get(`/api/web/release/notoken`,{params:data});
};

export const getWater = (params) => {
  return axios.get('/api/web/watermark/page',{params:params});
};
export const getComment = (id) => {
    return axios.patch(`/api/web/webcomment/${id}`);
};
export const getAppUrl = ({ type, bundleID }) => {
    return axios.put(`/api/web/version/new/${type}&${bundleID}`);
};
export const addCount = (id,type) => {
    return axios.post(`api/web/application/addCount/${id}&${type}`);
};
export const getFact = (id) => {
    return axios.get(`/api/web/webpersonalnews/share/${id}`);
};
export const getActLive2 = (id) => {
    return axios.get(`/api/live/activity/info/${id}`);
};
export const initTime = (time, type) => {
    let date = new Date(time);
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    let D = date.getDate();
    let H = date.getHours();
    let m = date.getMinutes();
    let s = date.getSeconds();
    //小于10的在前面补0
    if (M < 10) {
        M = "0" + M;
    }
    if (D < 10) {
        D = "0" + D;
    }
    if (H < 10) {
        H = "0" + H;
    }
    if (m < 10) {
        m = "0" + m;
    }
    if (s < 10) {
        s = "0" + s;
    }
    if (type == 1) {
        return `${Y}-${M}-${D} ${H}:${m}`;
    }else if (type == 2) {
      return `${Y}-${M}-${D} ${H}:${m}`;
    }else if (type == 3) {
      return `${M}-${D} ${H}:${m}`;
    }  else {
        return `${Y}-${M}-${D}`;
    }
};
export const getDateDiff = (dateStr) => {
    let publishTime = dateStr / 1000,
        d_seconds,
        d_minutes,
        d_hours,
        d_days,
        timeNow = parseInt(new Date().getTime() / 1000),
        d,
        date = new Date(publishTime * 1000),
        Y = date.getFullYear(),
        M = date.getMonth() + 1,
        D = date.getDate(),
        H = date.getHours(),
        m = date.getMinutes(),
        s = date.getSeconds();
    //小于10的在前面补0
    if (M < 10) {
        M = "0" + M;
    }
    if (D < 10) {
        D = "0" + D;
    }
    if (H < 10) {
        H = "0" + H;
    }
    if (m < 10) {
        m = "0" + m;
    }
    if (s < 10) {
        s = "0" + s;
    }

    d = timeNow - publishTime;
    d_days = parseInt(d / 86400);
    d_hours = parseInt(d / 3600);
    d_minutes = parseInt(d / 60);
    d_seconds = parseInt(d);

    if (d_days > 0 && d_days < 3) {
        return d_days + "天前";
    } else if (d_days <= 0 && d_hours > 0) {
        return d_hours + "小时前";
    } else if (d_hours <= 0 && d_minutes > 0) {
        return d_minutes + "分钟前";
    } else if (d_seconds < 60) {
        if (d_seconds <= 0) {
            return "刚刚";
        } else {
            return d_seconds + "秒前";
        }
    } else if (d_days >= 3 && d_days < 30) {
        return M + "-" + D
    } else if (d_days >= 30) {
        return Y + "-" + M + "-" + D
    }
};